<!-- Table widget: a native table, its header fixed over the scrolling rows -->
<div class="table-content" [style]="containerStyle" #htmlContent>
  @if (!isLoading()) {
  <div class="content-table">
    @if (showTitle && titlePosition == 'top') {
    <ng-container [ngTemplateOutlet]="titleBlock"></ng-container>
    }

    <div class="table-scroll" data-testid="widget-table">
      <table class="widget-table">
        <thead>
          <tr>
            @for (header of headers; track $index) {
            <th [style]="headerStyle" [class.num]="header.numeric">{{ header.name }}</th>
            }
          </tr>
        </thead>

        <tbody>
          @for (row of rows; track $index) {
          <tr>
            @for (cell of row; track $index) {
            <td [style]="valueStyle" [class.num]="cell.numeric">
              @switch (cell.format) {
                @case ('project') {
                <span class="pill">{{ cell.value }}</span>
                }
                @case ('chip') {
                <span class="pill" [ngClass]="'tone-' + cell.tone">{{ cell.value }}</span>
                }
                @case ('progress') {
                <span class="progress">
                  <span class="progress-track"><span class="progress-fill" [style.width.%]="cell.percent"></span></span>
                  <span class="progress-value">{{ cell.value }}</span>
                </span>
                }
                @default {
                {{ cell.value }}
                }
              }
            </td>
            }
          </tr>
          }
        </tbody>

        @if (totals) {
        <tfoot>
          <tr>
            @for (cell of totals; track $index) {
            <td [style]="valueStyle" [class.num]="cell.numeric">{{ cell.value }}</td>
            }
          </tr>
        </tfoot>
        }
      </table>
    </div>

    @if (showTitle && titlePosition != 'top') {
    <ng-container [ngTemplateOutlet]="titleBlock"></ng-container>
    }
  </div>
  }

  @if (widgetRendered) {
  <div id="chart-rendered"></div>
  }
  @if (isLoading()) {
  <app-widget-loading [graphType]="widget?.graphType"></app-widget-loading>
  }
</div>

<ng-template #titleBlock>
  <div class="block-label">
    @if (richTitle) {
    <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
    } @else {
    <p [style]="titleStyle">{{ title }}</p>
    }
    @if (error) {
    <span class="error">{{ error }}</span>
    }
  </div>
</ng-template>
